var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleInfoSolid1InactiveAdditionalInfol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.5C15.1522 22.5 17.6957 21.4464 19.5711 19.5711C21.4464 17.6957 22.5 15.1522 22.5 12.5C22.5 9.84784 21.4464 7.3043 19.5711 5.42893C17.6957 3.55357 15.1522 2.5 12.5 2.5C9.84784 2.5 7.3043 3.55357 5.42893 5.42893C3.55357 7.3043 2.5 9.84784 2.5 12.5C2.5 15.1522 3.55357 17.6957 5.42893 19.5711C7.3043 21.4464 9.84784 22.5 12.5 22.5ZM10.9375 15.625H11.875V13.125H10.9375C10.418 13.125 10 12.707 10 12.1875C10 11.668 10.418 11.25 10.9375 11.25H12.8125C13.332 11.25 13.75 11.668 13.75 12.1875V15.625H14.0625C14.582 15.625 15 16.043 15 16.5625C15 17.082 14.582 17.5 14.0625 17.5H10.9375C10.418 17.5 10 17.082 10 16.5625C10 16.043 10.418 15.625 10.9375 15.625ZM12.5 7.5C12.8315 7.5 13.1495 7.6317 13.3839 7.86612C13.6183 8.10054 13.75 8.41848 13.75 8.75C13.75 9.08152 13.6183 9.39946 13.3839 9.63388C13.1495 9.8683 12.8315 10 12.5 10C12.1685 10 11.8505 9.8683 11.6161 9.63388C11.3817 9.39946 11.25 9.08152 11.25 8.75C11.25 8.41848 11.3817 8.10054 11.6161 7.86612C11.8505 7.6317 12.1685 7.5 12.5 7.5Z",
    fill: "#B2B2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInfoSolid1InactiveAdditionalInfol);
export default __webpack_public_path__ + "static/media/circle-info-solid 1Inactive-AdditionalInfol.738abb1848122f9ff21f3e0aef90017d.svg";
export { ForwardRef as ReactComponent };